export default function loadScript(url, callback, attributes) {
  const script = document.createElement('script');
  script.type = 'text/javascript';
  if (attributes) {
    for (let attr in attributes) {
      script[attr] = attributes[attr];
    }
  }
  if (script.readyState) {
    //IE
    script.onreadystatechange = function() {
      if (script.readyState === 'loaded' || script.readyState === 'complete') {
        script.onreadystatechange = null;
        callback();
      }
    };
  } else {
    //Others
    script.onload = function() {
      callback();
    };
  }
  script.src = url;
  document.getElementsByTagName('head')[0].appendChild(script);
}
